// Mulberry32 — small, fast, 32-bit seeded PRNG. Plenty random for dice and shuffles.
// We carry the seed in GameState (rngSeed) so combat is replayable and tests are
// deterministic. After rolls, read getSeed() and store it back into the new state.

export interface Prng {
  /** Uniform [0, 1). */
  next(): number;
  /** Uniform integer in [0, maxExclusive). */
  nextInt(maxExclusive: number): number;
  /** Uniform integer in [1, 6]. */
  nextDie(): number;
  /** Current internal seed; advances on every call to next/nextInt/nextDie. */
  getSeed(): number;
}

export function createPrng(seed: number): Prng {
  let state = seed >>> 0;

  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  return {
    next,
    nextInt(maxExclusive: number): number {
      if (!Number.isFinite(maxExclusive) || maxExclusive <= 0) {
        throw new Error(`nextInt requires positive maxExclusive, got ${maxExclusive}`);
      }
      return Math.floor(next() * maxExclusive);
    },
    nextDie(): number {
      return Math.floor(next() * 6) + 1;
    },
    getSeed(): number {
      return state;
    },
  };
}
